import { render, staticRenderFns } from "./newCompraMedicina.vue?vue&type=template&id=669b7f64"
import script from "./newCompraMedicina.vue?vue&type=script&lang=js"
export * from "./newCompraMedicina.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports